export default {
    scripts: [],
    activeScript: {},
    manageScriptDialog: false,
    deleteScriptDialog: false
}
